import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';

const ServiciosPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServicesHero />
        <ServicesDetail />
      </main>
      <Footer />
    </div>
  );
};

export default ServiciosPage;